import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'traversia-ui';
  isLoading = false;
  constructor(
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // this.route.queryParams.subscribe((params) => { 
    //   if (params['Key']) {
    //     this.autoTokenLogin(params['Key']);
    //   }
    // });
    const url = window.location.href;        
    const queryString = url.split('?')[1];             
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const key = params.get('Key');         
      
      if (key) { 
        this.autoTokenLogin(key);                
      }
    }


    sessionStorage.removeItem('loader');
    setInterval(() => {
      if (sessionStorage.getItem('loader')) this.isLoading = true;
      else this.isLoading = false;
    }, 50);
  }

  autoTokenLogin(token: string) {
   const autoTokenKey = {
      encryptedKey: token,
    };
    this.http
      .post(`${environment.baseUrl}/auth/auto-login`, autoTokenKey)
      .subscribe({
        next: (res: any) => {
          if (res?.data) { 
             localStorage.removeItem('isLoggedIn');
            localStorage.setItem('isLoggedIn', JSON.stringify(res?.data));
            // this.router.navigate(['/home/assigned']);
            window.location.href = '/home/assigned'; 
          } else this.router.navigate(['/auth/login']);
        },
        error: (err) => {
          this.router.navigate(['/auth/login']);
        },
      });
  }
}
